"use client";

import { useProfile } from "@/context/useProfileProps";
import { useNetwork } from "@/hooks";
import { ToastType } from "@/types/common";
// import Toast from "@/components/settings/settingTabs/autoApplyNew/utils/Toast";
import { Toast } from "@monsterindia/global-ui-components";
import { AutoApplyNudge } from "@monsterindia/l1-apop";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

// import L1ApopWrapper from "@/components/profile/l1Card/component/l1Apop";
import { getValidateProfile } from "@/components/profile/l1Card/query";

import { API_ENDPOINT } from "../../../constants/appConstants";
import { AutoApplyData, AutoApplyProps } from "./AutoApplyTypes";
import L1ApopWrapper from "./components/l1Apop";

const AutoApply = dynamic<AutoApplyProps>(
  () => import("@foundit/autoApply/dist/index"),
  {
    ssr: false,
  },
);

const AutoApplyV2 = () => {
  const [autoApplyData, setAutoApplyData] = useState<AutoApplyData | null>(
    null,
  );
  const { data: validateProfileData } = getValidateProfile();
  const { isMobile } = useProfile();

  const [autoAppyPreferences, setAutoApplyPreference] = useState({
    roles: [],
    locations: [],
    skills: [],
  });

  const [showAutoApplyNudge, setShowAutoApplyNudge] = useState(false);
  const actionType = validateProfileData?.actionType ?? false;
  const [showL1Card, setShowL1Card] = useState(false);
  const [openToast, setOpenToast] = useState({
    show: false,
    message: "",
    type: "general",
  });
  const { fetchData: fetchAPI } = useNetwork();
  const toastHandler = ({ show, message, type = "general" }: ToastType) => {
    setOpenToast({
      show,
      message,
      type,
    });
  };

  const handleShowNudge = () => {
    if (validateProfileData.validateProfileResponse === 200) {
      setShowAutoApplyNudge(true);
    } else {
      if (actionType) {
        setShowL1Card(true);
      } else {
        setShowL1Card(false);
      }
    }
  };

  const closeAutoApplyPreference = () => {
    setShowAutoApplyNudge(false);
  };

  const fetchData = async () => {
    try {
      const res = await fetchAPI(
        `${API_ENDPOINT(window.location.host).middleware.profileDetails}?fields=job_preferences,skills_and_it_skills,auto_apply_status`,
        "GET",
      );

      const { data } = res;
      setAutoApplyData({
        auto_apply_status: data.auto_apply_status ?? {
          ...data.auto_apply_status,
          status: "INACTIVE",
        },
      });

      const autoAppyPreferences = {
        roles: data?.jobPreferenceSection?.jobPreference?.roles ?? [],
        locations: data?.jobPreferenceSection?.jobPreference?.locations ?? [],
        skills:
          data?.skillSection?.skills.map((skill: any) => {
            return {
              ...skill.skill,
            };
          }) ?? [], // Optional, Incremental
      };
      setAutoApplyPreference(autoAppyPreferences);
    } catch (error) {
      console.log("error");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAutoApplySubmit = async (data: any) => {
    try {
      const autoApplyResp = await fetchAPI(
        API_ENDPOINT(window.location.host).middleware.autoApplyV2,
        "POST",
        {},
        data,
      );

      if (!autoApplyResp.error) {
        toastHandler({
          show: true,
          message:
            "Smart Apply is now active for the next 90 days! 🎉 You can manage or turn it off anytime from Settings.",
          type: "success",
        });
        closeAutoApplyPreference();
        fetchData();
      } else {
        const error = JSON.parse(autoApplyResp.error);
        toastHandler({
          show: true,
          message:
            error.error.message.errorMessage ??
            "Something went wrong! Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      toastHandler({
        show: true,
        message: "Something went wrong! Please try again.",
        type: "error",
      });
    }
  };

  const removeL1Card = () => {
    setShowL1Card(false);
    setShowAutoApplyNudge(true);
  };

  return (
    <>
      {autoApplyData?.auto_apply_status?.feature_enabled === true && (
        <AutoApply data={autoApplyData} onClickBanner={handleShowNudge} />
      )}

      {showAutoApplyNudge && (
        <AutoApplyNudge
          preferences={autoAppyPreferences}
          autoApplyStatus={autoApplyData}
          onSubmitHandler={handleAutoApplySubmit}
          showNudge={showAutoApplyNudge}
          closeNudge={closeAutoApplyPreference}
          ctaText={
            autoApplyData && autoApplyData.auto_apply_status.is_expired
              ? "expired"
              : ""
          }
        />
      )}
      {showL1Card && (
        <L1ApopWrapper
          data={validateProfileData}
          removeL1Card={removeL1Card}
          showL1ApopOnEvent={showL1Card}
          eventData={null}
        />
      )}
      <Toast
        position="top-center"
        showToast={openToast.show}
        text={openToast.message}
        type={openToast.type}
        width={isMobile ? "75" : "50"}
        timer={5000}
        onClose={() =>
          toastHandler({
            show: false,
            message: "",
            type: "general",
          })
        }
      />
    </>
  );
};

export default AutoApplyV2;
